const ClipboardCheck = ( props ) => {
    const pathStroke = props.stroke || 'black';

    const styleB = {
        strokeWidth: 6.23,
        fill: '#fff',
        stroke: pathStroke,
    }

    const styleC = {
        fill: '#fff',
        stroke: pathStroke,
        strokeWidth: 24.92,
    }

    const styleD = {
        stroke: pathStroke,
        strokeMiterlimit: 10,
        strokeWidth: 6.23,
    }

    return (
        <svg id="a" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1080">
            <circle style={styleC} cx="685.73" cy="587.22" r="102.03"/>
            <path style={styleC} d="M628.7,579.12l42.37,42.37c.73.73,1.9.73,2.63,0l69.07-69.07"/>
            <path style={styleB} d="M631.5,370.14l-61.37-.25-.07,17.72c0,2.23-.93,4.25-2.4,5.7-1.46,1.46-3.48,2.35-5.71,2.34l-160.81-.66c-2.23,0-4.24-.93-5.69-2.39-1.46-1.46-2.36-3.49-2.35-5.72l.07-17.72-61.37-.25c-12.09-.05-21.96,9.74-22.01,21.82l-1.45,351.82c-.05,12.08,9.74,21.95,21.83,22l299.69,1.23c12.09.05,21.96-9.74,22.01-21.82h0s.25-61.95.25-61.95c-43.59-11.14-75.75-50.76-75.56-97.8.19-47.04,32.67-86.39,76.36-97.17l.39-94.9c.05-12.08-9.74-21.95-21.83-22Z"/>
            <path style={styleB} d="M554.13,339.08l-41.38-.17c-3.76-.02-7.01-2.63-7.83-6.3-2.4-10.78-11.87-18.34-23.04-18.39-11-.05-20.72,7.6-23.1,18.16-.84,3.68-4.12,6.3-7.89,6.28l-41.45-.17-.17,40.4,144.71.59.17-40.41Z"/>
            <path style={styleD} d="M651.88,743.95h0c-.05,12.09-9.92,21.88-22.01,21.83l-299.69-1.23c-12.09-.05-21.88-9.92-21.83-22l1.45-351.82c.05-12.08,9.92-21.87,22.01-21.82l61.37.25-.07,17.72c0,2.23.89,4.26,2.35,5.72,1.45,1.46,3.46,2.38,5.69,2.39l160.81.66c2.23,0,4.25-.88,5.71-2.34,1.47-1.45,2.39-3.47,2.4-5.7l.07-17.72,61.37.25c12.09.05,21.88,9.92,21.83,22l-.39,94.9c5.22-1.29,10.6-2.15,16.11-2.59l.38-92.24c.09-20.96-16.9-38.09-37.87-38.17l-61.39-.25.09-22.68c.02-4.44-3.57-8.07-8.02-8.09l-43.55-.18c-5.95-14.77-20.26-24.65-36.75-24.72-16.49-.07-30.89,9.7-36.9,24.42l-43.6-.18c-4.45-.02-8.07,3.57-8.09,8.02l-.09,22.68-61.39-.25c-20.97-.09-38.09,16.9-38.18,37.86l-1.45,351.81c-.09,20.96,16.9,38.09,37.87,38.17l299.69,1.23c20.97.09,38.09-16.9,38.18-37.86l.24-59.28c-5.5-.48-10.88-1.39-16.09-2.72l-.25,61.94ZM409.42,338.5l41.45.17c3.78.02,7.06-2.6,7.89-6.28,2.39-10.56,12.11-18.21,23.1-18.16,11.17.05,20.64,7.61,23.04,18.39.82,3.67,4.07,6.28,7.83,6.3l41.38.17-.17,40.41-144.71-.59.17-40.4Z"/>
        </svg>
    )
}
export default ClipboardCheck